import * as React from 'react';
import * as Common from '@telia-common-components/shared';
import { AddressEventsContainer } from './AddressEventsContainer';
import { AddressEventsProvider } from './AddressEventsProvider';
import { AddressEventsTable } from './AddressEventsTable';
const AddressEvents = (props) => {
    const addressProviderProps = {
        app: props.app,
        tier: props.tier,
        params: props.addressParams
    };
    const translationsProps = {
        translations: props.translations,
        isTestEnvironment: props.isTestEnvironment,
        disableTranslationsStatistics: props.disableTranslationsStatistics
    };
    return (React.createElement(Common.EnvironmentProvider, { app: props.app, tier: props.tier },
        React.createElement(AddressEventsProvider, { ...addressProviderProps },
            React.createElement(Common.TranslationsContextWrapper, { ...translationsProps },
                React.createElement(AddressEventsContainer, null, (eventsProps, translations, getSelfServiceLink) => {
                    return (React.createElement(AddressEventsTable, { addressEvents: eventsProps.addressEvents, newAddressEventUrl: eventsProps.newAddressEventUrl, providerStatus: eventsProps.status, translations: translations, tableProps: props.tableProps, buttonProps: props.buttonProps, cardProps: props.cardProps, showHeading: props.showHeading, showEmpty: props.showEmpty, showAddNewAddressEvent: props.showAddNewAddressEvent, getSelfServiceLink: getSelfServiceLink }));
                })))));
};
export { AddressEvents };
